var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.GetPdf}},[_vm._v("getpdf")]),_vm._v(" "),(_vm.url)?_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("open pdf")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }